import { Button, Card, CardBody, Col, Container, Form, Row } from "reactstrap";
import { AddPostTitle, Blog, Discard, Post, PostEditTitle } from "../../../../constants";
import PostEditForm from "./PostEditForm";
import Breadcrumbs from "../../../../coreComponents/breadcrumbs";
import CommonFileUpload from "../../../../coreComponents/CommonFileUpload";
import CommonCardHeader from "../../../../coreComponents/CommonCardHeader";

const AddPostContainer = () => {
  return (
    <>
      <Breadcrumbs mainTitle={AddPostTitle} parent={Blog} />
      <Container fluid>
        <Row>
          <Col sm="12">
            <Card>
              <CommonCardHeader title={PostEditTitle} />
              <CardBody className="add-post">
                <PostEditForm />
                <Form>
                  <CommonFileUpload />
                </Form>
                <div className="btn-showcase text-end">
                  <Button color="primary">{Post}</Button>
                  <Button color="transparent" className="bg-light font-dark">
                    {Discard}
                  </Button>
                </div>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default AddPostContainer;
